import { PATH_SURVEY } from "@configs";
import { IInfo, IMerchant } from "@interfaces";
import { useNotify } from "@utils";
import { useHistory } from "react-router";
import { IconPoint } from "../icon/Point";

interface IProps {
    image: string;
    title: string;
    point: string;
    id: string;
    isComplete: boolean;
    merchant: IMerchant;
}

export const BoxSurvey = (props: IProps) => {

    const { image, title, point, id, isComplete, merchant, } = props;
    const history = useHistory();
    const { success } = useNotify();

    const clickSurvey = () => {
        if (isComplete) {
            success("Already Submit this Survey");
        } else {
            history.push(PATH_SURVEY + "/" + id);
        }

    };
    return (
        <div className="box-product-survey" onClick={clickSurvey}>
            <div className="img-product-survey">
                <a>
                    <img src={image || "../images/img-survey-01.png"} alt="" />
                </a>
            </div>
            <div className="detail-product-survey">
                <div className="title-product-survey">
                    <a href="">{title || "Title Text"}</a>
                </div>
                {/* {merchant?.securityConfig?.isPointDisplay ?? (
                    <>
                        <div className="point-product-survey"><IconPoint /><span>{point || "0"}</span>Points</div>
                    </>
                )} */}
                {merchant?.securityConfig?.isPointDisplay ?
                    <div className="point-product-survey"><IconPoint /><span>{point || "0"}</span>Points</div>
                    :
                    null
                }
            </div>
        </div>
    );
};
